module.exports = __webpack_public_path__ + "static/media/d2.d7dd0d9a.jpg";